<nb-card>
  <nb-card-body>
    <div class="items-center info flex-grow-1 row" teamsGame>
      <ng-content class="col-auto" select="[number]"></ng-content>
      <div class="col-auto flex">
        <input #input nbInput class="form-control" placeholder="Type your search request here..." [(ngModel)]="searchInput" (keyup)="searchData($event)">
        <button nbButton ghost (click)="clearInput()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      <ng-content class="col-auto" select="[ActionsTeamsGame]"></ng-content>
    </div>
  </nb-card-body>
</nb-card>
<nb-card accent="info" class="">

  <div>
    <ng-content select="[voucher]"></ng-content>
    <nb-card-body>
      <div class="ml-4 mr-4">
        <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns" [pagination]="pagination"
          [loadingTemplate]="loadingTemplate" [noResultsTemplate]="noResultsTemplate" (event)="eventEmitted($event)">
        </ngx-table>
        
        <ng-content class="mt-4 col-auto" select="[pagination]"></ng-content>
        <!-- no tickets -->
        <ng-template #noResultsTemplate>
          <td [attr.colspan]="columns?.length" class="text-center">
            <p>no {{page}} found</p>
          </td>
        </ng-template>

        <!-- Loading -->
        <ng-template #loadingTemplate>
          <td [attr.colspan]="columns?.length">
            <div class="loader">Loading...</div>
          </td>
        </ng-template>
      </div>
    </nb-card-body>
  </div>
</nb-card>